import React from "react";
import { Link } from "react-router-dom";
import { IconType } from "react-icons";
import './MenuDesktopItem.scss';

type MenuDesktopItemProps = {
    label: string,
    icon: IconType,
    to: string,
    active?: boolean,
    disabled?: boolean,
};

function MenuDesktopItem(props: MenuDesktopItemProps) {

    return (
        <Link to={props.disabled ? '#' : props.to} className={`nostyle menu-desktop-item ${props.active ? 'active' : ''} ${props.disabled ? 'disabled' : ''}`}>
            {React.createElement(props.icon, { size: '1.2rem' })}
            <div className="menu-desktop-item-label">
                {props.label}
            </div>
        </Link>
    );
}

export default MenuDesktopItem;
